module.exports = __webpack_public_path__ + "img/curtain.82b63fee.png";